function securitySystemFinder() {
    document.addEventListener('DOMContentLoaded', () => {
        const updateSliderSteps = (slider) => {
            const stepsContainer = slider.closest('.security-finder-slider-stepper').querySelector('.security-finder-slider-steps');
            const steps = stepsContainer.querySelectorAll('.security-finder-slider-step');
            const value = parseFloat(slider.value);
            const stepSize = parseFloat(slider.step);
            const minValue = parseFloat(slider.min);

            const currentStepIndex = Math.round((value - minValue) / stepSize);

            steps.forEach((step, index) => {
                if (index === 0) return;
                step.style.display = index === currentStepIndex ? 'block' : 'none';
            });
        };

        document.querySelectorAll('.security-finder input[type="range"][data-slider]').forEach(slider => {
            updateSliderSteps(slider);
            slider.addEventListener('input', () => updateSliderSteps(slider));
        });

        document.addEventListener('click', (e) => {
            const button = e.target.closest('.security-finder-submit');
            if (!button) return;
            const form = button.closest('form.security-finder-form');
            if (!form) return;

            const getSliderValue = (name) => {
                const el = form.querySelector(`[data-slider="${name}"]`);
                return el ? el.value : '';
            };

            const data = {
                price: getSliderValue('price'),
                features: getSliderValue('features'),
                monitoring: getSliderValue('monitoring'),
                installation: getSliderValue('installation'),
                protection: getSliderValue('protection'),
                action: 'get_security_system_finder_results',
            };
            const errorMessage = form.querySelector('.security-finder-error-message');
            const finder = form.closest('.security-finder');

            if (errorMessage) errorMessage.style.display = 'none';
            button.disabled = true;

            fetch(window.site_settings.admin_ajax, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams(data),
            })
                .then(res => {
                    if (!res.ok) throw new Error('Network response was not ok');
                    return res.json();
                })
                .then(result => {
                    const res = result && result.data ? result.data : null;
                    if (
                        result && result.success &&
                        res && res.logo && res.title && res.cta_link
                    ) {
                        if (finder) finder.classList.add('success');
                        const resultsSection = form.querySelector('.security-finder-results');
                        if (resultsSection) {
                            const img = resultsSection.querySelector('img');
                            if (img) {
                                img.src = res.logo;
                                img.alt = res.title;
                            }

                            const cta = resultsSection.querySelector('.security-finder-results-cta-button');
                            if (cta) {
                                cta.href = res.cta_link;

                                [...cta.attributes].forEach(attr => {
                                    if (attr.name !== 'class' && attr.name !== 'href') {
                                        cta.removeAttribute(attr.name);
                                    }
                                });

                                if (res.cta_attr) {
                                    const attrRegex = /(\S+)=(["'])(.*?)\2/g;
                                    let match;
                                    while ((match = attrRegex.exec(res.cta_attr)) !== null) {
                                        cta.setAttribute(match[1], match[3]);
                                    }
                                }

                                if (res.cta_text) {
                                    cta.textContent = res.cta_text;
                                }
                            }

                            const highlights = resultsSection.querySelector('.security-finder-results-highlights');
                            if (highlights) {
                                highlights.innerHTML = '';
                                if (res.highlights) {
                                    highlights.innerHTML = res.highlights;
                                }
                            }
                        }
                        if (errorMessage) errorMessage.style.display = 'none';
                    } else {
                        if (errorMessage) errorMessage.style.display = 'block';
                        if (finder) finder.classList.remove('success');
                    }
                })
                .catch((e) => {
                    console.log('Error fetching security system finder results:', e);
                    if (errorMessage) errorMessage.style.display = 'block';
                    if (finder) finder.classList.remove('success');
                })
                .finally(() => {
                    button.disabled = false;
                });
        });

        document.addEventListener('click', (e) => {
            const tryAgainBtn = e.target.closest('.security-finder-try-again');
            if (!tryAgainBtn) return;
            const form = tryAgainBtn.closest('form.security-finder-form');
            if (!form) return;
            const finder = form.closest('.security-finder');
            if (finder) finder.classList.remove('success');
        });
    });
}

export default function init() {
    securitySystemFinder();
}
